<template lang="pug">
  li.item-header
    a
      .icon-header(v-bind:class="[(avatar == undefined || (avatar !== undefined && avatar === '')) && (icon === undefined || icon === '')? 'remove-img': '']")
        .avt-sidebar(v-if="avatar !== undefined && avatar !== ''")
          img(:src="avatar")
        .material-icons.text-gray(v-else-if="(avatar === undefined || !avatar) && !isAwesome(icon)") {{icon}}
        .fontawesome.text-gray(v-else)
          i(v-bind:class="[icon != '' ? icon : '']")
      .text-header(v-bind:class="[(avatar == undefined || (avatar !== undefined && avatar === '')) && (icon === undefined || icon === '')? 'full-text': '']")
        span.header {{title}}
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    avatar: String
  },
  methods: {
    isAwesome: function(text) {
      if (text !== undefined && text) {
        return text.indexOf('fa-') !== -1
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// itemHeader.vue?f45ed668